import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Eye, EyeClosed, EyeOff, Key, User } from "lucide-react";
import Captcha from "../compents/Captch";
import authService from "../Service/AuthService";
import { LoginRequest } from "../Entity/LoginRequest";
import { authenticateUser } from "../redux/authSlice"
import "./login.css";
import axios from "axios";
import Swal from "sweetalert2";

const API_URL = `${process.env.REACT_APP_URL}/auth/login`;

const Login = ({ logo }) => {
  const [loginData, setLoginData] = useState(LoginRequest);
  const [showPasswordChangeForm, setShowPasswordChangeForm] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [salt, setSalt] = useState('');

  const [isPasswordExpired, setIsPasswordExpired] = useState(false);
  const [isNicUserFirstTimeLogin, setIsNicUserFirstTimeLogin] = useState(false);
  const [isNicUserPasswordExpired, setIsNicUserPasswordExpired] =
    useState(false);

  const [errors, setErrors] = useState({
    username: "",
    password: "",
    captcha: "",
    passwordChange: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [err, setErr] = useState("");
  const [reCaptcha, setReCaptcha] = useState(null);

  const [isActive, setIsActive] = useState({
    username: false,
    password: false,
    captcha: false,
    passwordChange: false,
  });

  const handleFocus = (e) => {
    setIsActive((prevData) => ({ ...prevData, [e.target.name]: true }));
  };

  const handleBlur = (e) => {
    if (e.target.value === "") {
      setIsActive((prevData) => ({ ...prevData, [e.target.name]: false }));
    }
  };

  const dispatch = useDispatch();
  const navigator = useNavigate();

  const changeHandler = (e) => {
    setLoginData((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value,
    }));

    if (e.target.value !== "") {
      setIsActive((prevData) => ({ ...prevData, [e.target.name]: true }));
    }
  };

  const validation = () => {
    let valid = true;
    const errorsCopy = { ...errors };

    // Username validation
    const validateUsername = loginData.username.trim();
    const regex = /^[a-zA-Z0-9_.-]+$/;

    if (!validateUsername) {
      errorsCopy.username = "Username is required";
      valid = false;
    } else if (!regex.test(validateUsername)) {
      errorsCopy.username = "Username contains invalid characters!";
      valid = false;
    } else if (validateUsername.length > 20) {
      errorsCopy.username = "Username must be less than 20 characters long!";
      valid = false;
    } else {
      errorsCopy.username = "";
    }

    // Password validation
    const validatePassword = loginData.password.trim();
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]).{8,20}$/;

    if (!validatePassword) {
      errorsCopy.password = "Password is required";
      valid = false;
    } else if (!passwordRegex.test(validatePassword)) {
      errorsCopy.password =
        "Password must be 8-20 characters long, contain uppercase, lowercase letters, numbers, and special characters!";
      valid = false;
    } else {
      errorsCopy.password = "";
    }
    // Captcha validation
    const validateCaptcha = loginData.captcha.trim();
    const captchaRegex = /^[A-Za-z0-9]{6}$/;
    if (!validateCaptcha) {
      errorsCopy.captcha = "Captcha is required";
      valid = false;
    } else if (!captchaRegex.test(validateCaptcha)) {
      errorsCopy.captcha =
        "invalid characters in captcha! Please enter 6 characters using only letters and numbers";
      valid = false;
    } else {
      errorsCopy.captcha = "";
    }

    setErrors(errorsCopy);
    return valid;
  };


  const handleLogin = async (loginData) => {
    setIsLoading(true);
    setErr("");

    try {
      const hashedPassword = await hashInput(loginData.password.trim()).then((data) => { return data });
      const saltedHashedPassword = await hashInput(salt + hashedPassword).then((data) => { return data });

      const loginPayload = {
        ...loginData,
        password: saltedHashedPassword
      };

      const response = await axios.post(`${API_URL}`, loginPayload);


      if (!response.data.success) {
        //if fails
        // First-time login specific check
        if (response.status === 400 && response.data.message === "YES") {

          //reset the login Data to default
          setLoginData((prevData) => ({
            ...prevData,
            password: "",
            captcha: "",
          }));
          setShowPasswordChangeForm(true);
          //setErr("First-time login detected. Please change your password.");

          return;
        }
        if (
          response.status === 400 &&
          response.data.message === "YES-EXPIRED"
        ) {
          setIsPasswordExpired(true);
          setShowPasswordChangeForm(true);

          //reset the login Data to default
          setLoginData((prevData) => ({
            ...prevData,
            password: "",
            captcha: "",
          }));
          // setErr("First-time login detected. Please change your password.");
          return;
        }

        setLoginData((prevData) => ({
          ...prevData,
          username: "",
          password: "",
          captcha: "",
        }));
        setErr(response.data.message);
      }

      // Handle successful login
      if (response.data && response.data.success) {
        //reset the login Data to default
        setLoginData((prevData) => ({
          ...prevData,
          username: "",
          password: "",
          captcha: "",
        }));

        document.cookie = `isAuth=true; path=/`;
        sessionStorage.setItem(
          "person",
          JSON.stringify(response.data.data.token)
        );
        dispatch(
          authenticateUser({
            isAuthenticated: true,
            token: response.data.data.token,
          })
        );
        navigator("/home");
      }
    } catch (error) {

      console.error("FULL LOGIN ERROR:", error);

      // Comprehensive error logging
      if (error.response) {


        if (!error.response.data.success) {
          //if fails
          // First-time login specific check
          if (
            error.response.status === 400 &&
            error.response.data.message === "YES"
          ) {
            console.error("Response Details:", error.response);
            setShowPasswordChangeForm(true);
            setLoginData((prevData) => ({
              ...prevData,
              password: "",
              captcha: "",
            }));
            return;
          }
          if (
            error.response.status === 400 &&
            error.response.data.message === "YES-EXPIRED"
          ) {
            console.error("Response Details:", error.response);
            setIsPasswordExpired(true);
            setShowPasswordChangeForm(true);
            setLoginData((prevData) => ({
              ...prevData,
              password: "",
              captcha: "",
            }));
            return;
          }
          if (
            error.response.status === 400 &&
            error.response.data.message === "NIC-YES"
          ) {
            console.error("Response Details:", error.response);
            setIsNicUserFirstTimeLogin(true);
            // setIsPasswordExpired(true);
            setShowPasswordChangeForm(true);
            setLoginData((prevData) => ({
              ...prevData,
              password: "",
              captcha: "",
            }));
            return;
          }
          if (
            error.response.status === 400 &&
            error.response.data.message === "YES-EXPIRED-NIC"
          ) {
            console.error("Response Details:", error.response);

            setIsPasswordExpired(true);
            setIsNicUserPasswordExpired(true);
            setShowPasswordChangeForm(true);
            setLoginData((prevData) => ({
              ...prevData,
              password: "",
              captcha: "",
            }));
            return;
          }

          if (
            error.response.status === 400 &&
            error.response.data.message === "Invalid captcha"
          ) {
            console.error("Response Details:", error.response);

            setLoginData((prevData) => ({
              ...prevData,
              username: "",
              captcha: "",
            }));
            console.error(error.response.data.data);
            setErr(error.response.data.message);
            setReCaptcha(error.response.data.data);
            return;
          }

          setErr(error.response.data.message);
        }
      }

      // Generic error handling
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Login failed. Please try again.";

      setLoginData((prevData) => ({
        ...prevData,
        username: "",
        password: "",
        captcha: "",
      }));
      setErr(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    if (validation()) {
      setIsLoading(true);
      await handleLogin(loginData);
    }
  };
  const hashInput = async (input) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(input);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    return hashHex;
  };
  /*

CHANGE THE PASSWORD WHEN

1. USER IS REGISTERED FIRST TIME
2. PASSWORD OF THE USER IS EXPIRED...



*/
  const handlePasswordChange = async () => {
    // Reset previous errors
    setErrors((prev) => ({ ...prev, passwordChange: "", captcha: "" }));

    // Password validation for new password
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]).{8,20}$/;

    if (!newPassword || !confirmPassword) {
      setErrors((prev) => ({
        ...prev,
        passwordChange: "Both fields are required",
      }));
      return;
    }

    if (!passwordRegex.test(newPassword)) {
      setErrors((prev) => ({
        ...prev,
        passwordChange:
          "Password must be 8-20 characters long, contain uppercase, lowercase letters, numbers, and special characters!",
      }));
      return;
    }

    if (newPassword !== confirmPassword) {
      setErrors((prev) => ({
        ...prev,
        passwordChange: "Passwords do not match!",
      }));
      return;
    }

    //captcha validation
    const validateCaptcha = loginData.captcha.trim();
    const captchaRegex = /^[A-Za-z0-9]{6}$/;
    if (!validateCaptcha) {
      setErrors((prev) => ({
        ...prev,
        captcha: "Captcha is required",
      }));
      return;
    }

    if (!captchaRegex.test(validateCaptcha)) {
      setErrors((prev) => ({
        ...prev,
        captcha:
          "Invalid characters in captcha! Please enter 6 characters using only letters and numbers",
      }));
      return;
    }

    try {
      const hashedPasswordShaed = await hashInput(confirmPassword.trim()).then((data) => { return data });
      const newPasswordShaed = await hashInput(newPassword.trim()).then((data) => { return data });
      setIsLoading(true);
      if (isNicUserFirstTimeLogin || isNicUserPasswordExpired) {
        const response = await authService.changeNicUserPassword({
          username: loginData.username,
          password: hashedPasswordShaed,
          newPassword: newPasswordShaed,
          captcha: loginData.captcha,
        });

        // Handle successful password change
        if (response.data && response.success) {
          await Swal.fire({
            title: "Success!",
            text: response.message || "Password changed successfully. You will be logged out.",
            icon: "success",
            confirmButtonText: "OK",
          });
          setShowPasswordChangeForm(false);
          navigator("/logout");
          return;
        } else {
          setErrors((prev) => ({
            ...prev,
            passwordChange:
              response.message || "Failed to change the password.",
          }));
        }
      } else {
        const response = await authService.changePassword({
          username: loginData.username,
          password: hashedPasswordShaed,
          newPassword: newPasswordShaed,
          captcha: loginData.captcha,
        });

        // Handle successful password change
        if (response.data && response.success) {
          await Swal.fire({
            title: "Success!",
            text: response.message || "Password changed successfully. You will be logged out.",
            icon: "success",
            confirmButtonText: "OK",
          });
          setShowPasswordChangeForm(false);
          navigator("/logout");
          return;
        } else {
          setErrors((prev) => ({
            ...prev,
            passwordChange:
              response.message || "Failed to change the password.",
          }));
        }
      }
    } catch (error) {
      ////
      console.error("In catch block...", error);
      // Comprehensive error logging
      if (error.response) {
        console.error("Error Response Status:", error.response.status);
        console.error("Error Response Data:", error.response.data);

        if (!error.response.data.success) {
          //if fails
          if (error.response.status === 400) {
            setErrors((prev) => ({
              ...prev,
              passwordChange: error.response.data.message,
            }));

            setNewPassword("");
            setConfirmPassword("");
            setLoginData((prevData) => ({
              ...prevData,
              captcha: "",
            }));

            if (error.response.data.message === "Invalid captcha") {
              console.error("Response Details:", error.response);
              setLoginData((prevData) => ({
                ...prevData,
                captcha: "",
              }));
              setReCaptcha(error.response.data);
              return;
            }
          }
        }
      }

      ////
    } finally {
      setIsLoading(false);
    }
  };

  /**
   *
   * END OF THE handlePasswordChange
   *
   *
   */
  useEffect(() => {
    // Check if loginData is available
    if (loginData) {
      setIsActive((prevData) => ({
        ...prevData,
        username: loginData.username != null ? false : true,
        password: loginData.password != null ? false : true,
        captcha: loginData.captcha != null ? false : prevData.captcha,
      }));
    }
  }, []);

  const [eyeOpened, setEyeOpened] = useState(false);

  //change the eye...
  const changeEyeHandler = (e) => {
    e.preventDefault();
    setEyeOpened((prevData) => !prevData);
  };
  return (
    <div className="login">
      <div className="loginContainer">
        {!showPasswordChangeForm ? (
          <form className="loginForm" onSubmit={submitHandler} autoComplete="off">
            <div className="headerDiv">
              {/* <img
                style={{ width: "100px", height: "80px" }}
                src="/images/dddn.png"
                alt="Left"
              /> */}
              <h5>Login</h5>
            </div>

            <div className="form-group2" id="loginForm">
              <div className="input-wrapper">
                <User color="black" size={18} />
                <input
                  type="text"
                  id="username"
                  value={loginData.username}
                  name="username"
                  onChange={changeHandler}
                  style={{ marginBottom: "0px" }}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  maxLength={20}
                  autoComplete="off"
                />
                <span
                  className={`floating-label ${isActive.username ? "active" : ""
                    }`}
                >
                  Username
                </span>
              </div>
              {errors.username && (
                <span className="invalid-feedback d-block">
                  {errors.username}
                </span>
              )}
            </div>

            <div className="form-group2">
              <div className="input-wrapper">
                <Key color="black" size={18} />
                <input
                  type={eyeOpened ? "test" : "password"}
                  id="password"
                  name="password"
                  value={loginData.password}
                  onChange={changeHandler}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  maxLength={20}
                  autoComplete="off"
                />

                <span
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "30%",
                    cursor: "pointer",
                    backgroundColor: "inherit",
                    padding: "0px",
                  }}
                  onClick={changeEyeHandler}
                >
                  {eyeOpened ? (
                    <Eye color="#555" size={18} />
                  ) : (
                    <EyeOff color="#555" size={18} />
                  )}
                </span>
                <span
                  className={`floating-label ${isActive.password ? "active" : ""
                    }`}
                >
                  password
                </span>
              </div>
              {errors.password && (
                <span className="invalid-feedback d-block">
                  {errors.password}
                </span>
              )}
            </div>

            <Captcha onSaltChange={setSalt} reCaptcha={reCaptcha} />

            <div className="form-group1">
              <input
                type="text"
                name="captcha"
                id="captcha"
                maxLength="6"
                value={loginData.captcha}
                onChange={changeHandler}
                style={{ width: "100%", padding: "12px" }}
                onFocus={handleFocus}
                onBlur={handleBlur}
                autoComplete="one-time-code"
              />
              <span
                className={`floating-label ${isActive.captcha ? "active" : ""}`}
              >
                captcha
              </span>
              {errors.captcha && (
                <span className="invalid-feedback d-block">
                  {errors.captcha}
                </span>
              )}
            </div>

            <div className="signinBtn">
              <button
                type="submit"
                className="loginButton"
                disabled={isLoading}
              >
                {isLoading ? <div className="spinner"></div> : "Login"}
              </button>
            </div>

            {err && (
              <div
                className="errorDiv invalid-feedback d-block"
                style={{ height: "30px" }}
              >
                {err}
              </div>
            )}
          </form>
        ) : (
          <div className="passwordChangeForm">
            <form
              className="loginForm"
              style={{ width: "100%" }}
              onSubmit={(e) => {
                e.preventDefault();
                handlePasswordChange();
              }}
              autoComplete="off"
            >
              <div className="headerDiv">
                {logo && (
                  <img
                    src={`data:image/jpeg;base64,${logo}`}
                    alt="logo"
                    style={{ width: "70px", height: "70px" }}
                  />)}
                <h5>
                  {isPasswordExpired
                    ? isNicUserPasswordExpired
                      ? "NIC User password Expired - Change Password "
                      : "Password Expired - Change Password"
                    : isNicUserFirstTimeLogin
                      ? "NIC User First Time Login - Change Password"
                      : "First Time Login - Change Password"}
                </h5>
              </div>
              <div className="form-group1">
                <label>New Password:</label>
                <input
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="Enter new password"
                  style={{ padding: "10px" }}
                  maxLength={20}
                  autoComplete="new-password"
                />
              </div>

              <div className="form-group1">
                <label>Confirm Password:</label>
                <input
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Confirm new password"
                  style={{ padding: "10px" }}
                  maxLength={20}
                  autoComplete="new-password"
                />
              </div>

              <Captcha onSaltChange={setSalt} reCaptcha={reCaptcha} />

              <div className="form-group1">
                <input
                  type="text"
                  placeholder="Captcha"
                  name="captcha"
                  id="captcha"
                  maxLength="6"
                  value={loginData.captcha}
                  onChange={changeHandler}
                  style={{ width: "100%", border: "1px solid #ccc" }}
                  autoComplete="off"
                />
                {errors.captcha && (
                  <span className="invalid-feedback d-block">
                    {errors.captcha}
                  </span>
                )}
              </div>

              <div className="signinBtn" style={{ marginBottom: "10px" }}>
                <button
                  type="submit"
                  className="loginButton"
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <div className="spinner"></div>
                  ) : (
                    "reset password"
                  )}
                </button>
              </div>
              {errors.passwordChange && (
                <span className="invalid-feedback d-block">
                  {errors.passwordChange}
                </span>
              )}
            </form>
          </div>
        )}
        {/* <div className="loginFormFooterContents">
          <LoginFooter />
        </div> */}
      </div>
    </div>
  );
};

export default Login;
